import React, { useState, useEffect, useMemo } from "react";
//i added useMemeo!
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import {
  getData,
  postData,
  putData,
  deleteData,
} from "../../FetchNodeServices";
import Select from "react-select";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";

const ESurveyForm = () => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState("");
  const [isFormVisible, setFormVisible] = useState(true);
  const [isSettingsVisible, setSettingsVisible] = useState(false);
  const [isSecurityVisible, setSecurityVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [projectName, setProjectName] = useState("");

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [languageList, setlanguageList] = useState([]);

  const [isDataChanged, setDataChanged] = useState(false);
  const [projectCode, setProjectCode] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [browserTitle, setBrowserTitle] = React.useState("");
  const [browserList, setBrowserList] = useState([]);
  const [surveyName, setSurveyName] = useState("");
  const [surveyTypeId, setSurveyTypeId] = React.useState("");
  const [surveyTypeList, setSurveyTypeList] = useState([]);
  const [surveyStatusId, setSurveyStatusId] = React.useState("");
  const [surveyStautsList, setSurveyStatusList] = useState([]);
  const [countryId, setCountryId] = React.useState([]); // Initialize as an array
  const [countryList, setCountryList] = useState([]);
  const [termsPolicy, setTermsPolicy] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [footerContent, setFooterContent] = useState("");
  const [helpLink, setHelpLink] = useState("");
  const [alert, setAlerts] = useState("");
  const [isTermsPolicyOpen, setIsTermsPolicyOpen] = useState(false);
  const [isFooterContentOpen, setIsFooterContentOpen] = useState(false);
  const [isHelpLinkOpen, setIsHelpLinkOpen] = useState(false);
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  const [isProgressBarOpen, setIsProgressBarOpen] = useState(true);
  const [isFooterOpen, setIsFooterOpen] = useState(true);
  const [surveyCode, setSurveyCode] = useState(true);
  const customer = useSelector((state) => state.user.users[0]);
  const [userId, setUserId] = useState("");
  const user = useMemo(() => customer?.userId || "", [customer]);
  const [surveyId, setSurveyId] = useState("");

  const [vpnSelection, setVpnSelection] = useState(null);
  const [cookieSelection, setcookieSelection] = useState(null);
  const [duplicateipSelection, setduplicateipSelection] = useState(null);
  const [uniqueipSelection, setuniqueipSelection] = useState(null);
  const [geoipSelection, setgeoipSelection] = useState(null);
  const location = useLocation();
  const item = location.state?.item;
  var survey = item.surveyId;
  console.log(item);

  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleFormToggle = () => {
    setFormVisible(!isFormVisible);
  };

  const handleSettingsToggle = () => {
    setSettingsVisible(!isSettingsVisible);
  };

  const handleSecurityToggle = () => {
    setSecurityVisible(!isSecurityVisible);
  };

  const handlegeoipChange = (event) => {
    setgeoipSelection(event.target.value === "yes" ? 1 : 0);
  };

  const handleuniqueipChange = (event) => {
    setuniqueipSelection(event.target.value === "yes" ? 1 : 0);
  };

  const handleduplicateipChange = (event) => {
    setduplicateipSelection(event.target.value === "yes" ? 1 : 0);
  };

  const handlecookieChange = (event) => {
    setcookieSelection(event.target.value === "yes" ? 1 : 0);
  };

  const handleVpnChange = (event) => {
    setVpnSelection(event.target.value === "yes" ? 1 : 0);
  };
  const handleToggles = (e) => {
    // Toggle the state
    setIsProgressBarOpen(!isProgressBarOpen);
    // Check the updated state and log the corresponding value
    console.log(!isProgressBarOpen, "value");
  };

  const handleFooterToggleChange = () => {
    setIsFooterOpen(!isFooterOpen);
    const newValue = !isFooterOpen;
    console.log(newValue, "value");
  };

  const handlePrivacyPolicyToggleChange = () => {
    setIsPrivacyPolicyOpen(!isPrivacyPolicyOpen);
    const newValue = !isPrivacyPolicyOpen;
    console.log(newValue, "value");
  };

  const handleTermsPolicyToggleChange = () => {
    setIsTermsPolicyOpen(!isTermsPolicyOpen);
    const newValue = !isTermsPolicyOpen;
    console.log(newValue, "value");
  };

  const handleFooterContentToggleChange = () => {
    setIsFooterContentOpen(!isFooterContentOpen);
    const newValue = !isFooterContentOpen;
    console.log(newValue, "value");
  };

  const handleHelpLinkToggleChange = () => {
    setIsHelpLinkOpen(!isHelpLinkOpen);
    const newValue = !isHelpLinkOpen;
    console.log(newValue, "value");
  };

  useEffect(() => {
    // Fetch initial data from the database
    const fetchSurveyDetails = async () => {
      setIsLoading(true);
      try {
        let result = await getData("users/get-survey/" + survey);
        if (result) {
          console.log(
            "Actual Result: " +
            JSON.stringify(result.surveySetting.browserTitle)
          );

          console.log("aa gayo:" + result);
          setSurveyId(result.surveyDetailsId);
          setProjectName(result.projectName);
          setProjectCode(result.projectCode);
          setSurveyName(result.surveyName);
          setSurveyCode(result.surveyCode);
          setSurveyTypeId(result.surveyType);
          setCountryId(
            result.countryIds.split(",").map((id) => parseInt(id.trim()))
          );
          setSelectedLanguages(
            result.langIds.split(",").map((id) => parseInt(id.trim()))
          );
          setSurveyStatusId(result.surveyStatus);
          setBrowserTitle(result.surveySetting.browserTitle);
          console.log("test:", result.surveySetting.browserTitle);
          setIsProgressBarOpen(
            result.surveySetting.progressBarEnabled === 1 ? true : false
          );
          setIsFooterOpen(
            result.surveySetting.footerEnabled === 1 ? true : false
          );
          setIsTermsPolicyOpen(
            result.surveySetting.termsConditionsEnabled === 1 ? true : false
          );
          setTermsPolicy(result.surveySetting.termsConditions);
          setIsPrivacyPolicyOpen(
            result.surveySetting.privacyPolicyEnabled === 1 ? true : false
          );
          setPrivacyPolicy(result.surveySetting.privacyPolicy);
          setIsFooterContentOpen(
            result.surveySetting.footerContentEnabled === 1 ? true : false
          );
          setFooterContent(result.surveySetting.footerContent);
          setIsHelpLinkOpen(
            result.surveySetting.helpLinkEnabled === 1 ? true : false
          );
          setHelpLink(result.surveySetting.helpLink);
          setVpnSelection(result.surveySecurity.proxyVpnEnabled);
          setuniqueipSelection(result.surveySecurity.uniqueIpEnabled);
          setgeoipSelection(result.surveySecurity.geoIpEnabled);
          setduplicateipSelection(result.surveySecurity.duplicateIdEnabled);
          setcookieSelection(result.surveySecurity.cookieEnabled);
        }
      } catch (error) {
        console.error("Error fetching survey data:", error);
        setAlerts([
          { variant: "danger", heading: "Error fetching survey data." },
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSurveyDetails();
  }, []);
  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (!surveyName) {
      isValid = false;
      tempErrors["surveyName"] = "Survey Name is required!";
    }
    if (!surveyStatusId) {
      isValid = false;
      tempErrors["surveyStatus"] = "Survey Status is required!";
    }
    if (!countryId) {
      isValid = false;
      tempErrors["countryId"] = "Country is required!";
    }
    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!handleValidation()) {
      return;
    }
    const formData = {
      userId: user,
      surveyDetailsId: surveyId,
      projectName: projectName,
      langIds: selectedLanguages.map((id) => id).join(","),
      projectCode: projectCode,
      surveyName: surveyName,
      surveyCode: surveyCode,
      surveyType: surveyTypeId,
      surveyStatus: surveyStatusId,
      countryIds: countryId.map((id) => id).join(","),
      surveySetting: {
        userId: user,
        surveyDetailsId: surveyId,
        brandingEnabled: 1,
        browserTitle: browserTitle,
        progressBarEnabled: isProgressBarOpen ? 1 : 0,
        footerEnabled: isFooterOpen ? 1 : 0,
        helpLinkEnabled: isHelpLinkOpen ? 1 : 0,
        helpLink: helpLink,
        termsConditionsEnabled: isTermsPolicyOpen ? 1 : 0,
        termsConditions: termsPolicy,
        privacyPolicyEnabled: isPrivacyPolicyOpen ? 1 : 0,
        privacyPolicy: privacyPolicy,
        footerContentEnabled: isFooterContentOpen ? 1 : 0,
        footerContent: footerContent,
      },
      surveySecurity: {
        userId: user,
        deviceEnabled: 2,
        deviceAllowed: "No",
        browserEnabled: 0,
        browserAllowed: "No",
        surveySpeedersEnabled: 1,
        timestampSsMinTime: "14",
        timestampSsMaxTime: "6",
        queSpeedersEnabled: 0,
        timestampQsMinTime: "7",
        timestampQsMaxTime: "8",
        geoIpEnabled: geoipSelection,
        uniqueIpEnabled: uniqueipSelection,
        duplicateIdEnabled: duplicateipSelection,
        reEntryEnabled: 0,
        cookieEnabled: cookieSelection,
        proxyVpnEnabled: vpnSelection,
        captureRespondentPhotoEnabled: 0,
        captureRespondentVideoEnabled: 0,
        digitalFingerPrintingEnabled: 0,
        backButtonEnabled: 0,
        otpEnabled: 0,
        otpSmsEnabled: 0,
        otpEmailEnabled: 0,
        otpCallEnabled: 0,
        printScreenEnabled: 0,
        sourceCodeEnabled: 0,
        imageVideoDownloadingEnabled: 0,
      },
    };

    setIsLoading(true);

    try {
      const result = await putData(`users/update-survey/`, formData);
      if (result) {
        console.log("Survey Updated successfully:", result);
        setAlerts([
          { variant: "success", heading: "Survey Created Successfully!" },
        ]);
      }
      navigate("/survey-listing"); // Redirect to survey listing
    } catch (error) {
      console.error("Error submitting form:", error);
      setAlerts([{ variant: "danger", heading: "Error submitting form." }]);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCountryChange = (selectedOptions) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const selectedIds = selectedOptions.map((option) => option.value);
      setCountryId(selectedIds); // Update state with the selected country IDs as an array
    } else {
      setCountryId([]); // If no options are selected, set state to an empty array
    }
  };
  const handleLanguageChange = (selectedOptions) => {
    // Check if selectedOptions exists and is an array
    if (Array.isArray(selectedOptions)) {
      // Map the selected options to their respective values (IDs)
      const selectedIds = selectedOptions.map((option) => option.value);
      setSelectedLanguages(selectedIds); // Update the state with the selected language IDs
    } else {
      // If no options are selected or invalid data, set an empty array
      setSelectedLanguages([]);
    }
  };

  const handleSurveyTypeChange = (selectedOption) => {
    setSurveyTypeId(selectedOption.value);
  };

  const handleSurveyStatusChange = (selectedOption) => {
    setSurveyStatusId(selectedOption.value);
  };

  const fetchCountry = async () => {
    setIsLoading(true);
    let result = await getData("users/country");
    setCountryList(result);
    setIsLoading(false);
  };

  const fetchLanguage = async () => {
    setIsLoading(true);
    let result = await getData("users/country/language");
    setlanguageList(result);
    setIsLoading(false);
  };

  const fetchSurveyType = async () => {
    setIsLoading(true);
    let result = await getData("users/survey-types");
    setSurveyTypeList(result);
    setIsLoading(false);
  };

  const fetchSurveyStatus = async () => {
    setIsLoading(true);
    let result = await getData("users/survey-status");
    setSurveyStatusList(result);
    setIsLoading(false);
  };

  useEffect(function () {
    fetchSurveyStatus();
    fetchSurveyType();
    fetchCountry();
    fetchLanguage();
  }, []);
  const fillCountry = () => {
    return countryList
      .filter((item) => item.countryId && item.countryName) // Ensure both values are present
      .map((item) => ({
        value: item.countryId,
        label: item.countryName,
      }));
  };

  const fillLanguage = () => {
    return languageList
      .filter((item) => item.langId && item.language) // Ensure both values are present
      .map((item) => ({
        value: item.langId,
        label: item.language,
      }));
  };

  const fillSurveyType = () => {
    return surveyTypeList.map((item) => {
      return { value: item.genericValueId, label: item.genericValue };
    });
  };

  const fillSurveyStatus = () => {
    return surveyStautsList.map((item) => {
      return { value: item.genericValueId, label: item.genericValue };
    });
  };

  const handleDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await deleteData("users/delete-survey/" + survey);
        if (result) {
          Swal.fire({
            title: "Deleted!",
            text: "Your Survey has been deleted.",
            icon: "success",
          });
          navigate("/survey-listing");
        } else {
          Swal.fire({
            title: "Error!",
            text: "Failed to delete the Survey.",
            icon: "error",
          });
        }
      }
    });
  };
  const handleLanguageRemove = (selectedList, removedItem) => {
    const selectedIds = selectedList.map((option) => option.value);
    setSelectedLanguages(selectedIds); // Update state with the remaining language IDs
  };

  const handleCountryRemove = (selectedList, removedItem) => {
    const selectedIds = selectedList.map((option) => option.value);
    setCountryId(selectedIds); // Update state with the remaining language IDs
  };
  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {Object.keys(errors).length > 0 && (
          <div className="error-summary">
            <ul>
              {Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}
        <div className="container-fluid py-3">
          <div className="row">
            <div className="col-lg-9">
              <div className="card border-light-subtle">
                <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height ">
                  <li className="nav-item">
                    <Link to="/survey-form">
                      <a
                        className="nav-link active"
                        aria-current="page"
                        href="#"
                      >
                        Survey Form
                      </a>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/survey-programming">
                      <a className="nav-link" href="#">
                        Questions
                      </a>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/view-quota">
                      <a className="nav-link" href="#">
                        Quota
                      </a>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Field Work</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Survey Data</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Stats</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Analysis</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Reports</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/survey-form">
                <li>
                  <i className="bi bi-people"></i> Survey Form
                </li>
              </Link>
            </ul>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Basic Details
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleFormToggle}
                >
                  <i
                    className={`bi ${isFormVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />
              {isFormVisible && (
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Project Name</label>
                      <input
                        type="text"
                        value={projectName}
                        className="form-control"
                        placeholder="Project Name"
                        onChange={(event) => setProjectName(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="language-select">Language</label>
                      <Multiselect
                        id="languageSelect"
                        options={fillLanguage()}
                        selectedValues={selectedLanguages.map((id) => {
                          const option = fillLanguage().find(
                            (option) => option.value === id
                          );
                          return option
                            ? option
                            : { value: id, label: "Unknown Language" }; // Handle undefined options
                        })}
                        displayValue="label" // Matches the 'label' key from fillLanguage()
                        onSelect={handleLanguageChange}
                        onRemove={handleLanguageRemove}
                        showCheckbox
                        placeholder={
                          selectedLanguages.length > 4
                            ? selectedLanguages.length + " selected"
                            : "Select Languages"
                        }
                        isLoading={isLoading}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Project Code</label>
                      <input
                        type="text"
                        value={projectCode}
                        className="form-control"
                        placeholder="Project Code"
                        onChange={(event) => setProjectCode(event.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Browser Title</label>
                      <input
                        type="text"
                        value={browserTitle}
                        className="form-control"
                        placeholder="Project Code"
                        onChange={(event) =>
                          setBrowserTitle(event.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Name</label>
                      <input
                        type="text"
                        value={surveyName}
                        className="form-control"
                        placeholder="Survey Name"
                        onChange={(event) => setSurveyName(event.target.value)}
                      />
                      {errors.surveyName && (
                        <span className="text-danger">{errors.surveyName}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Type</label>

                      <Select
                        options={fillSurveyType()}
                        value={fillSurveyType().find(
                          (option) => option.value === surveyTypeId
                        )}
                        onChange={handleSurveyTypeChange}
                        placeholder="Select Survey Type"
                        isSearchable
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Status</label>

                      <Select
                        options={fillSurveyStatus()}
                        value={fillSurveyStatus().find(
                          (option) => option.value === surveyStatusId
                        )}
                        onChange={handleSurveyStatusChange}
                        placeholder="Select Survey Status"
                        isSearchable
                      />
                      {errors.surveyStatus && (
                        <span className="text-danger">
                          {errors.surveyStatus}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Country</label>
                      <Multiselect
                        id="countrySelect"
                        options={fillCountry()}
                        selectedValues={countryId.map((id) => {
                          const option = fillCountry().find(
                            (option) => option.value === id
                          );
                          return option
                            ? option
                            : { value: id, label: "Unknown Country" }; // Fallback if not found
                        })}
                        displayValue="label"
                        onSelect={handleCountryChange}
                        onRemove={handleCountryRemove}
                        showCheckbox
                        placeholder={countryId.length > 4
                          ? countryId.length + " selected"
                          : "Select Countries"
                        }
                        isLoading={isLoading}
                      />
                      {errors.countryId && (
                        <span className="text-danger">{errors.countryId}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <br />

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Basic Settings
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleSettingsToggle}
                >
                  <i
                    className={`bi ${isSettingsVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />

              {isSettingsVisible && (
                <div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center mb-3 ">
                        <label className="me-2">Progress Bar:</label>

                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={isProgressBarOpen}
                            onChange={handleToggles}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center mb-3">
                        <label className="me-2">Footer:</label>

                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={isFooterOpen}
                            onChange={handleFooterToggleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {isFooterOpen && (
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Terms & Policy</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="termsPolicyOpen"
                              checked={isTermsPolicyOpen}
                              onChange={handleTermsPolicyToggleChange}
                            />
                          </div>
                        </div>
                        {isTermsPolicyOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={termsPolicy}
                              className="form-control mt-2"
                              placeholder="Terms & Policy"
                              onChange={(event) =>
                                setTermsPolicy(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Privacy Policy</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="privacyPolicyOpen"
                              checked={isPrivacyPolicyOpen}
                              onChange={handlePrivacyPolicyToggleChange}
                            />
                          </div>
                        </div>
                        {isPrivacyPolicyOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={privacyPolicy}
                              className="form-control mt-2"
                              placeholder="Privacy Policy"
                              onChange={(event) =>
                                setPrivacyPolicy(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Footer Content</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="footerContentOpen"
                              checked={isFooterContentOpen}
                              onChange={handleFooterContentToggleChange}
                            />
                          </div>
                        </div>
                        {isFooterContentOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={footerContent}
                              className="form-control mt-2"
                              placeholder="Footer Content"
                              onChange={(event) =>
                                setFooterContent(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Help Link</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="helpLinkOpen"
                              checked={isHelpLinkOpen}
                              onChange={handleHelpLinkToggleChange}
                            />
                          </div>
                        </div>
                        {isHelpLinkOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={helpLink}
                              className="form-control mt-2"
                              placeholder="Help Link"
                              onChange={(event) =>
                                setHelpLink(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <br />
          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Security Options
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleSecurityToggle}
                >
                  <i
                    className={`bi ${isSecurityVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />
              {isSecurityVisible && (
                <>
                  <div className="row">
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">GeoIP</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="geoipCheckboxYes"
                            value="yes"
                            checked={geoipSelection === 1 ? true : false}
                            onChange={handlegeoipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="geoipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="geoipCheckboxNo"
                            value="no"
                            checked={geoipSelection === 0 ? true : false}
                            onChange={handlegeoipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="geoipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Unique IP</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="uniqueipCheckboxYes"
                            value="yes"
                            checked={uniqueipSelection === 1 ? true : false}
                            onChange={handleuniqueipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="uniqueipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="uniqueipCheckboxNo"
                            value="no"
                            checked={uniqueipSelection === 0 ? true : false}
                            onChange={handleuniqueipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="uniqueipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Duplicate Id</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="duplicateipCheckboxYes"
                            value="yes"
                            checked={duplicateipSelection === 1 ? true : false}
                            onChange={handleduplicateipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="duplicateipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="duplicateipCheckboxNo"
                            value="no"
                            checked={duplicateipSelection === 0 ? true : false}
                            onChange={handleduplicateipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="duplicateipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Cookie</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="cookieCheckboxYes"
                            value="yes"
                            checked={cookieSelection === 1 ? true : false}
                            onChange={handlecookieChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cookieipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="cookieipCheckboxNo"
                            value="no"
                            checked={cookieSelection === 0 ? true : false}
                            onChange={handlecookieChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cookieipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Proxy/VPN</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="vpnCheckboxYes"
                            value="yes"
                            checked={vpnSelection === 1 ? true : false}
                            onChange={handleVpnChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="vpCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="vpCheckboxNo"
                            value="no"
                            checked={vpnSelection === 0 ? true : false}
                            onChange={handleVpnChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="vpCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Repeat similar structure for other security options */}
                  </div>

                  <br />
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn bg-danger-subtle text-danger"
                        onClick={() => handleDelete()}
                      >
                        Delete Survey
                      </button>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSubmit();
                        }}
                      >
                        {/* Form fields here */}
                        <button
                          type="button"
                          className="btn btn-success px-4"
                          onClick={() => handleSubmit()}
                        >
                          {isDataChanged ? "Update" : "Update Survey"}
                        </button>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ESurveyForm;
